import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Col, Row, Table } from "react-bootstrap";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ApiUiController from "../../../controller/ApiUiController";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import { FaPrint } from "react-icons/fa";
import CallTalkTimeReport from "./CallTalktimeReport";
import CallFeedbackReport from "./CallFeedback";
import MeetingFeedback from "./MeetingFeedback";
import CallInOutReport from "./CallInOut";
import DailyLeadStatus from "./DailyLeadStatus";
import DailySalesLeadSource from "./DailyLeadSource";
import DailySalesLeadByProject from "./DailyLeadsByProject";
import DailySalesLeadsByPropertyType from "./leadsByPropertyType";
import DailySalesLeadByRentSale from "./DailyLeadsByRentSale";
import DailyMeetingByProject from "./DailyMeetingByProject";
import ChartComponent from './../FixedReportChart';
import { IoCall } from "react-icons/io5";
import { FaRupeeSign, FaRegAddressCard, FaMapMarkedAlt } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import StatCard from "../../dashboard/mydashboardcomponent/StatCard";
import SalesOrderAPI from "../../../api/SalesOrderAPI";
import Display from "../../../util/Display";
import Util from "../../../util/Util";
import MeetingAPI from "../../../api/MeetingAPI";
import CallAPI from "../../../api/CallAPI";
import LeadAPI from "../../../api/LeadAPI";
import StackedChartComponent from "../chartComponent/MultiBarChart";

class DailySalesReportPage extends React.Component {
  constructor(props) {
    super(props);
    const { selectedIds, dateFrom, dateTo, dateCondition } = props;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.dateCondition = dateCondition;
    this.userOptions = reactLocalStorage.getObject(Constants.Model).user.options;
    this.user = reactLocalStorage.getObject(Constants.LoggedInUser);
    this.models = reactLocalStorage.getObject(Constants.Model);
    this.leadStatusOptions = this.models.lead.fields['progress'].options;
    this.leadSourceOptions = this.models.source.options;
    this.updatedLeadStatusOptions = [];
    this.updatedLeadSourceOptions = [];
    this.selectedIds = selectedIds || [];
    this.completeOptions = [{ label: 'Complete', value: 1 }, { label: 'Pending', value: 0 },];
    this.state = {
      leadsData: [],
      meetingsData: [],
      callsData: [],
      quotesData: [],
      revenueData: [],
      callTalktimeData: [],
      users: {},
      leadCount: 0,
      callCount: 0,
      callStats: { completed: 0, pending: 0 },
      callTalkTime: "0h 0m",
      meetingCount: 0,
      meetingStats: { completed: 0, pending: 0 },
      salesCount: 0,
      salesAmount: 0,
      propertyCount: 0,
      propertyStats: { available: 0, booked: 0 },
      hourlyCallData: [],
      siteVisitData: [],
      leadSourceData: [],
      inApiCall: true,
    };
  }


  getResponsibleFilter = () => {
    const id = `~${this.selectedIds.join('~')}~`;
    return id;
  };

  fetchAllStats = () => {
    this.fetchLeadCount();
    this.fetchCallCount();
    this.fetchMeetingCount();
    this.fetchSalesOrder();
    this.fetchLeadStatus();
    this.fetchLeadSource();
    this.fetchLatestMeetings();
  };

  fetchLeadCount = () => {
    const filters = [
      {
        field: "responsible_person",
        condition: "in",
        value: this.getResponsibleFilter()
      }
    ];
    filters.push({
      field: "enquiry_date",
      condition: "in",
      value: `${this.dateFrom}~${this.dateTo}`
    });

    const list = {
      filters,
      pagination: { currentPage: 1, perPage: 1 }
    };

    LeadAPI.count(
      list,
      (response) => this.setState({ leadCount: response?.count || 0 }),
      (error) => console.error("Failed to fetch lead count:", error)
    );
  };

  fetchCallCount = () => {
    const filters = [
      {
        field: "responsible_person",
        condition: "in",
        value: this.getResponsibleFilter()
      }
    ];
    filters.push({
      field: "date_time",
      condition: "in",
      value: `${this.dateFrom}~${this.dateTo}`
    });

    const list = {
      filters,
      pagination: { currentPage: 1, perPage: 10000 }
    };

    CallAPI.getList(
      list,
      (response) => {
        const allCalls = response?.data || [];

        const completed = allCalls.filter(call => call.complete === 1).length;
        const pending = allCalls.filter(call => call.complete === 0).length;
        const totalDurationSec = allCalls
          .filter(call => call.duration)
          .reduce((sum, call) => sum + call.duration, 0);

        const formatDuration = (seconds) => {
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          return `${hours}h ${minutes}m`;
        };

        const hourlyMap = {};
        for (let i = 9; i <= 21; i++) hourlyMap[i] = 0;

        allCalls.forEach(call => {
          if (call.complete === 1 && call.date_time) {
            const dateObj = Util.serverStringDateTimeToDate(call.date_time);
            if (dateObj) {
              const localHour = dateObj.getHours();
              if (hourlyMap[localHour] !== undefined) {
                hourlyMap[localHour]++;
              }
            }
          }
        });

        const hourlyData = Object.keys(hourlyMap).map(hour => ({
          hour: `${(hour % 12 || 12)} ${hour < 12 ? 'AM' : 'PM'}`,
          count: hourlyMap[hour]
        }));

        this.setState({
          callCount: allCalls.length,
          callStats: { completed, pending },
          callTalkTime: formatDuration(totalDurationSec),
          hourlyCallData: hourlyData
        });
      },
      (error) => console.error("Failed to fetch call list:", error)
    );
  };

  fetchMeetingCount = () => {
    const filters = [
      {
        field: "responsible_person",
        condition: "in",
        value: this.getResponsibleFilter()
      }
    ];
    filters.push({
      field: "date_time",
      condition: "in",
      value: `${this.dateFrom}~${this.dateTo}`
    });

    const list = {
      filters,
      pagination: { currentPage: 1, perPage: 10000 }
    };

    MeetingAPI.getList(
      list,
      (response) => {
        const allMeetings = response?.data || [];
        const completed = allMeetings.filter(m => m.complete === 1).length;
        const pending = allMeetings.filter(m => m.complete === 0).length;

        this.setState({
          meetingCount: allMeetings.length,
          meetingStats: { completed, pending }
        });
      },
      (error) => console.error("Failed to fetch meeting list:", error)
    );
  };

  fetchLatestMeetings = () => {
    const filters = [
      {
        field: "responsible_person",
        condition: "in",
        value: this.getResponsibleFilter()
      }
    ];

    const list = {
      filters,
      pagination: { currentPage: 1, perPage: 10000 }
    };

    MeetingAPI.getList(
      list,
      (response) => {
        const allMeetings = response?.data || [];
        const recentVisits = allMeetings
          .filter(m => m.complete === 1)
          .sort((a, b) => new Date(b.date_time) - new Date(a.date_time))
          .slice(0, 7)
          .map(meeting => ({
            id: meeting.id,
            leadName: meeting.lead_first || "N/A",
            phone: (meeting.lead_phone || '').replace(/~/g, '') || "N/A",
            datetime: meeting.date_time,
            displayDate: Util.serverStringToDisplayDate(meeting.date_time),
            displayTime: Util.serverStringToDisplayTime(meeting.date_time),
            feedback: Display.FieldValue(meeting, 'feedback', this.models['meeting'].fields),
            comment: meeting.comment || "",
            modelId: meeting.model_id,
            modelNo: meeting.model_no,

          }));

        this.setState({ siteVisitData: recentVisits });
      },
      (error) => console.error("Failed to fetch recent meetings:", error)
    );
  };


  fetchSalesOrder = () => {
    const filters = [
      { field: "responsible_person", condition: "in", value: this.getResponsibleFilter() }
    ];
    filters.push({
      field: "end_date",
      condition: "in",
      value: `${this.dateFrom}~${this.dateTo}`
    });
    const list = {
      filters,
      pagination: { currentPage: 1, perPage: 10000 }
    };

    SalesOrderAPI.getList(
      list,
      (response) => {
        const allSales = response?.data || [];
        const totalAmount = allSales.reduce((sum, s) => sum + parseFloat(s.total || 0), 0);
        this.setState({ salesCount: allSales.length, salesAmount: totalAmount });
      },
      (error) => console.error("Failed to fetch sales orders:", error)
    );
  };

  fetchLeadStatus = () => {
    const filters = [
      { field: "responsible_person", condition: "in", value: this.getResponsibleFilter() },
      { field: "enquiry_date", condition: "in", value: `${this.dateFrom}~${this.dateTo}`, }
    ];

    const list = {
      filters,
      model: "lead_model",
      x: "progress",
      y: "",
      z: "COUNT(id)"
    };

    DailySalesReportAPI.getFixedReport(
      list,
      (response) => {
        const updated = this.leadStatusOptions.map(opt => {
          const match = response.find(r => r.progress === opt.value);
          return { name: opt.label, value: opt.value, count: match ? match.sum : 0 };
        });
        this.updatedLeadStatusOptions = updated;
      },
      (error) => console.error("Failed to fetch lead status:", error)
    );
  };

  fetchLeadSource = () => {
    const filters = [
      { field: "responsible_person", condition: "in", value: this.getResponsibleFilter() },
      { field: "enquiry_date", condition: "in", value: `${this.dateFrom}~${this.dateTo}` }
    ];

    const list = {
      filters,
      model: "lead_model",
      x: "source",
      y: "",
      z: "COUNT(id)"
    };

    DailySalesReportAPI.getFixedReport(
      list,
      (response) => {
        const updated = this.leadSourceOptions.map(opt => {
          const match = response.find(r => r.source === opt.value);
          return { name: opt.label, value: match ? match.sum : 0 };
        });

        this.setState({ leadSourceData: updated });
      },
      (error) => console.error("Failed to fetch lead source:", error)
    );
  };


  componentDidMount() {
    const createFilters = (type) => [
      {
        field: { lead: "enquiry_date", meeting: "date_time", call: "date_time", quote: "created_date", revenue: "end_date", property: "created_date" }[type],
        type: "datetime",
        condition: this.dateCondition,
        value: `${this.dateFrom}~${this.dateTo}`,
      },
      {
        field: "responsible_person",
        condition: "in",
        value: this.selectedIds,
      },
    ];

    // Fetch data for all three types
    ["lead", "meeting", "call", "revenue", "property"].forEach((type) =>
      DailySalesReportAPI.list(
        type,
        createFilters(type),
        (res) => this.onReceived(`${type}sData`, res),
        this.onFail
      )
    );
    this.fetchAllStats();
  }

  UNSAFE_componentWillReceiveProps(nwprops) {
    const { selectedIds, dateFrom, dateTo, dateCondition } = nwprops;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.dateCondition = dateCondition;
    this.selectedIds = selectedIds;
    const createFilters = (type) => [
      {
        field: { lead: "enquiry_date", meeting: "date_time", call: "date_time", quote: "created_date", revenue: "end_date", property: "created_date" }[type],
        type: "datetime",
        condition: this.dateCondition,
        value: `${this.dateFrom}~${this.dateTo}`,
      },
      {
        field: "responsible_person",
        condition: "in",
        value: this.selectedIds,
      },
    ];

    // Fetch data for all three types
    ["lead", "meeting", "call", "revenue", "property"].forEach((type) =>
      DailySalesReportAPI.list(
        type,
        createFilters(type),
        (res) => this.onReceived(`${type}sData`, res),
        this.onFail
      )
    );
    this.fetchAllStats();
  }

  onReceived = (dataType, res) => {
    const users = this.userOptions
      .filter(({ status }) => [Constants.Active, Constants.AlwaysActive].includes(status))
      .reduce((acc, { value, name }) => {
        acc[value] = name;
        return acc;
      }, {});

    this.setState({ [dataType]: res, users, inApiCall: false });
  };

  onFail = () => {
    this.setState({ inApiCall: false });
  };

  processData = (data) => {
    const userSums = this.selectedIds.reduce((acc, id) => ({ ...acc, [id]: 0 }), {});
    data.forEach(({ responsible_person, sum }) => {
      const ids = typeof responsible_person === "string"
        ? responsible_person.split("~").filter(Boolean)
        : [String(responsible_person)];
      ids.forEach((id) => {
        if (this.selectedIds.includes(Number(id))) {
          userSums[id] += sum;
        }
      });
    });

    return {
      processedData: this.selectedIds.map((id) => ({
        userId: id,
        name: this.state.users[id],
        sum: userSums[id],
      })),
      totalSum: Object.values(userSums).filter(Boolean).reduce((a, b) => a + b, 0),
    };
  };


parseData = (response) => {  
  // Prepare table data
  const tableData = this.completeOptions.map((comp) => {
    const row = { complete: comp.label };

    this.userOptions
      .filter((user) => this.selectedIds.includes(user.value))
      .forEach((user) => {
        const userId = user.value;
        let totalSum = 0;

        response.forEach((item) => {
          if (item.complete == comp.value) {
            if (typeof item.responsible_person === 'string') {
              const ids = item.responsible_person.split('~').filter(Boolean);
              if (ids.includes(userId.toString())) {
                totalSum += (item.sum || 0);
              }
            } else if (item.responsible_person == userId) {
              totalSum += (item.sum || 0);
            }
          }
        });

        row[user.label] = totalSum;
      });

    return row;
  });

  // Prepare chart series
  const series = this.userOptions
    .filter((user) => this.selectedIds.includes(user.value))
    .map((user) => {
      const userId = user.value;

      const data = this.completeOptions.map((comp) => {
        let totalSum = 0;

        response.forEach((item) => {
          if (item.complete == comp.value) {
            if (typeof item.responsible_person === 'string') {
              const ids = item.responsible_person.split('~').filter(Boolean);
              if (ids.includes(userId.toString())) {
                totalSum += (item.sum || 0);
              }
            } else if (item.responsible_person == userId) {
              totalSum += (item.sum || 0);
            }
          }
        });

        return totalSum;
      });

      return {
        name: user.label,
        data,
      };
    });
  return { tableData, series };
};


  renderTable = (title, data) => {
    const { processedData, totalSum } = this.processData(data);
    // Prepare data for chart
    const progressSums = processedData.reduce((acc, { userId, sum }) => {
      acc[userId] = sum;
      return acc;
    }, {});

    // Define chart options (categories or labels)
    const progressOptions = this.selectedIds.map((id) => ({
      label: this.state.users[id],
      value: id,
    }));

    return (
      <>
        <h2>{title} by Sales Executive</h2>
        <hr />
        <div className="row">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Sales Executive</th>
                <th>Total {title}</th>
              </tr>
            </thead>
            <tbody>
              {processedData.map(({ userId, name, sum }, index) => (
                <tr key={index} onClick={() => this.handleClick(userId)}>
                  <td>{name}</td>
                  <td>{sum}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>

          <div className="col-md-6">
            {/* Pass progressSums and progressOptions to ChartComponent */}
            <ChartComponent progressSums={progressSums} progressOptions={progressOptions} type={"line"} />
          </div>
        </div>
      </>
    );
  };

  renderCallMeetingTable = (title, data) => {
    const { tableData, series } = this.parseData(data);
    return (
      <>
        <h2>{title} by Sales Executive</h2>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Complete</th>
                  {this.userOptions.filter((user) => this.selectedIds.includes(user.value)).map((person, index) => (
                    <th key={index}>{person.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.complete}</td>
                    {this.userOptions.filter((user) => this.selectedIds.includes(user.value)).map((person, idx) => (
                      <td key={idx}>{row[person.label]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            {/* Pass progressSums and progressOptions to ChartComponent */}
            <StackedChartComponent progressOptions={this.completeOptions} progressSums={series} type={"multiBar"} />
          </div>
        </div>
      </>
    );
  };

  render() {
    const { leadsData, meetingsData, callsData, inApiCall, leadCount, callCount, callStats, callTalkTime, meetingCount, meetingStats, salesCount, salesAmount } = this.state;
    const names = this.selectedIds.map((id) => this.state.users[id]).join(", ");
    const datePeriod = `${this.dateFrom.split(" ")[0]} to ${this.dateTo.split(" ")[0]}`;
    const [startDate, endDate] = datePeriod.split(" to ");
    const startDateFormat = `${startDate.split("-")[2]}-${startDate.split("-")[1]}-${startDate.split("-")[0]}`;
    const endDateFormat = `${endDate.split("-")[2]}-${endDate.split("-")[1]}-${endDate.split("-")[0]}`;
    const datePeriodFormat = `${startDateFormat} to ${endDateFormat}`;
    const filter = { dateCondition: this.dateCondition, dateFrom: this.dateFrom, dateTo: this.dateTo, selectedIds: this.selectedIds, };

    const topStats = [
      { icon: FaRegAddressCard, title: (<>Leads</>), count: leadCount, color: "#007bff" },
      {
        icon: IoCall, title: (<>Calls</>), count: callCount, color: "#28a745",
        subtext: (
          <div style={{ display: 'flex', gap: '1rem', fontSize: '0.875rem', fontWeight: 500 }}>
            <span style={{ color: '#28a745' }}>Completed: {callStats.completed}</span>
            <span style={{ color: '#FF0000' }}>Pending: {callStats.pending}</span>
          </div>
        )
      },
      { icon: BsClockHistory, title: (<>Call Talktime </>), count: callTalkTime, color: "#20c997" },
      {
        icon: FaMapMarkedAlt, title: (<>Site Visits </>), count: meetingCount, color: "#ffc107",
        subtext: (
          <div style={{ display: 'flex', gap: '1rem', fontSize: '0.875rem', fontWeight: 500 }}>
            <span style={{ color: '#28a745' }}>Completed: {meetingStats.completed}</span>
            <span style={{ color: '#FF0000' }}>Pending: {meetingStats.pending}</span>
          </div>
        )
      },
      {
        icon: FaRupeeSign, title: (<>My Bookings</>), count: salesCount, color: "#6f42c1",
        subtext: (
          <div style={{ fontSize: '0.875rem', marginTop: '6px', color: '#495057' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 500 }}>
              <FaRupeeSign style={{ fontSize: '0.85rem', color: '#6f42c1' }} />
              INR: {salesAmount?.toLocaleString('en-IN')}
            </span>
          </div>
        )
      }
    ];
    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="m-4">
          <h1 className="text-center">Daily Sales Report</h1>
          <hr />
          <div className="d-flex justify-content-between align-items-center mb-4">
            {/* Left Side: Names and Date Period */}
            <div>
              <p><strong>Sales Executives:</strong> {names || "N/A"}</p>
              <p><strong>Date Period:</strong> {datePeriodFormat}</p>
            </div>
            {/* Right Side: Print Button */}
            <button
              className="btn btn-primary d-flex align-items-center"
              onClick={() => window.print()}
            >
              <FaPrint className="m-2" /> Print
            </button>
          </div>
          <div
            className="mb-3 mt-2"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)", // 5 equal cards
              gap: "12px",
            }}
          >
            {topStats.map((stat, index) => (
              <StatCard key={index} {...stat} />
            ))}
          </div>

          {this.renderTable("Leads", leadsData)}
          <DailyLeadStatus filters={filter} />
          <DailySalesLeadSource filters={filter} />.  
          <DailySalesLeadByProject filters={filter} />
          {this.renderCallMeetingTable("Calls", callsData)}
          <CallTalkTimeReport filters={filter} />
          <CallFeedbackReport filters={filter} />
          <CallInOutReport filters={filter} />
          {this.renderCallMeetingTable("Site Visit", meetingsData)}
          <MeetingFeedback filters={filter} />
          <DailyMeetingByProject filters={filter} />
          <DailySalesLeadsByPropertyType filters={filter} />
          <DailySalesLeadByRentSale filters={filter} />
          {/* <DailyPropertyBySalesPerson  filters={filter}/> */}
          {/* {this.renderTable("Booking Report", meetingsData)} */}
          {/* {this.renderTable("Sales", revenueData)} */}
        </div>
      </ApiUiController>
    );
  }

}

export default withRouter(DailySalesReportPage);